import React, {useEffect} from 'react';
import PropTypes from "prop-types";
import MovieCardList from "../MovieCardList";
import withFetch from "../../hocs/withFetch";

const MoviesInTheaters = ({onSucess, data, isLoading}) => {
  useEffect(() => {
    if(!isLoading)
      onSucess()
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);
  if(!isLoading && data.errorType && data.errorType === "CountryNotFound")
    return <></>
  else
    return <MovieCardList sectionName="en-cartelera" isLoading={isLoading} data={data} external={false} />
};

MoviesInTheaters.propTypes = {
  onSucess: PropTypes.func,
  data: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        image: PropTypes.string,
        title: PropTypes.string,
        href: PropTypes.string,
      })
    ),
    PropTypes.objectOf(PropTypes.string)
  ]),
  isLoading: PropTypes.bool
};
/*
 data: [
    {
      image: process.env.PUBLIC_URL+"/images/black-widow-movie-card.png",
      title: "BLACK WIDOW",
      slug: "black-widow",
    },
    {
      image: process.env.PUBLIC_URL+"/images/soul-movie-card.png",
      title: "SOUL",
      slug: "soul",
    },
    {
      image: process.env.PUBLIC_URL+"/images/new-mutants-movie-card.png",
      title: "LOS NUEVOS MUTANTES",
      slug: "los-nuevos-mutantes",
    }
  ],
  */
MoviesInTheaters.defaultProps = {
  isLoading: false,
};

// export default withFetch(MoviesInTheaters, `movies?region=${process.env.REACT_APP_REGION}`, true, false, ['city']);
export default withFetch(MoviesInTheaters, `movies?region=${process.env.REACT_APP_REGION}`, true, false, ['city'], true);